/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import PreguntaForm from './PreguntaForm';
import * as validations from '../../validations/validations';
import * as preguntaActions from '../../actions/preguntaActions';
import * as formularioActions from '../../actions/formularioActions';

import * as paginaActions from '../../actions/paginaActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes} from '../../util/';
import $ from 'jquery';

class ManagePreguntaForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
			pregunta:{
                    }
		};
		
	}
    
    
    componentDidMount(){
        
        let id=this.props.id;
        let pageInfo={ 
            page:'pregunta', 
            idioma:this.props.idioma     
        }; 
   this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);  
       this.props.paginaActions.getInfo(pageInfo, this.props.user).then( pageInfoResponse=>{ 
           this.setState({"permisos":pageInfoResponse.permisos, 
                         "strings":Object.assign({}, pageInfoResponse.strings)}); 
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        }); 
        if(id && id>0 ){
            
           this.props.preguntaActions.getPregunta(id, this.props.user).then( pregunta=>{
               this.setState({"pregunta":pregunta});
           })
            .catch(error=>{
              toastr.error(error);
            }); 
        }
        
        this.props.formularioActions.getFormularioCombo(this.props.user).then()
            .catch(error=>{
              toastr.error(error);
            }); 
        
        
		
    }
    

    handleChange=(event, data)=> {

        let pregunta = this.state.pregunta;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		pregunta[field[0]]= value;
		else{
             if(!pregunta[field[0]]){
                    pregunta[field[0]]={}
                }
			pregunta[field[0]][field[1]]= value;
		}
        
		
        this.setState({"pregunta": pregunta});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let pregunta=this.state.pregunta;
              
        if(!validations.requerido(pregunta.idFormulario)){
            errors.idFormulario=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(pregunta.nombre)){
            errors.nombre=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(pregunta.tipo)){
            errors.tipo=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        
        this.props.preguntaActions.save(this.state.pregunta, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            //this.props.history.push('/preguntas');
        });
        
    }

       
    render() {	
          
   let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
              <Segment  style={margenes}>
                <PreguntaForm 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.pregunta}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    formularioCombo={genericFormattedForDropdown(this.props.formularioCombo)}
                    
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    let id = ownProps.match.params.id;
        
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        id,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        color:state.color,
        user:state.user, 
        idioma:state.idioma,
        form:state.form,
        formularioCombo:state.formularioCombo
    }

}

function mapDispatchToProps(dispatch){

	return {   
            showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
            paginaActions: bindActionCreators(paginaActions, dispatch),
            preguntaActions: bindActionCreators(preguntaActions, dispatch),
            formularioActions:bindActionCreators(formularioActions, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManagePreguntaForm);